import styled from 'styled-components';


export const Container = styled.div`



width: 100%;
height: 100%;


display: flex;
flex-direction: column;
align-items: center;


#secundSubTitle{
    margin: 70px;
}

`;
export const Title = styled.h1`

    color: #333b3f;
    font-size: 210px;

`;

export const SubTitle = styled.h5`


   color: #333b3f;
    font-family: 'Open Sans', sans-serif;
    margin: 10px 0;
    font-size: 21px;



`;
